import { useSnackbar } from 'notistack';
import { useMutation } from 'react-query';

import { axios } from 'lib';

const updateBlogPostRequest = async ({
  blogID,
  title,
  description,
  content,
  tag,
  picture,
  creatorID,
}) => {
  const formData = new FormData();

  formData.append('title', title);
  formData.append('description', description);
  formData.append('content', content);
  formData.append('tag', tag);
  formData.append('file', picture?.file);
  formData.append('creator_id', creatorID);
  formData.append('file_ext', 'png');
  
  return await axios.put(`/api/blogs/${blogID}`,formData)
};

export const useUpdate = (refetch) => {
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: updateBlogPostRequest,
    onSuccess: () => {
      enqueueSnackbar('Blog post was successfully updated', {
        variant: 'success',
      });

      refetch();
    },
    onError: (error) => {
      enqueueSnackbar(error?.message || 'Some error occured', { variant: 'error' });
    },
  });
};
